var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"network-header"},[_c('MapIcon',_vm._b({attrs:{"size":30}},'MapIcon',_vm.networkIcon,false)),_c('span',[_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.$tc('models.network', 1)))+" ")]),_c('span'),(_vm.network)?_c('span',[_vm._v(" "+_vm._s(_vm.network.name)+" ")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }